import React from 'react';
import { useSelector } from 'react-redux';
import { fitBounds } from 'google-map-react';

import useDeepUpdate from '@src/libs/hooks/useDeepUpdate';
import { getSpacesBounds } from '@src/containers/Map/selectors/getSpacesBounds';
import { loadSpacesParams } from '@src/containers/SpacesListing/selectors/loadSpacesParams';
import { useFetchSpacesPoints } from '@src/containers/Map/hooks/useFetchSpacesPoints';
import useMapActions from '@src/containers/Map/hooks/useActions';
import { getSpacesPoints } from '@src/containers/Map/selectors/getSpacesPoints';
import { getInitCoords } from '@src/containers/Map/selectors/getInitCoords';
import MarkerPrice from '@src/components/MarkerPrice';
import MarkerPoint from '@src/components/MarkerPoint';

import Map from './default';

import { isInsideBounds } from '../helpers';

const MapCSpaces = (props) => {
	const boundsRef = React.useRef();
	const params = useSelector(loadSpacesParams);
	const defaultBounds = useSelector(getSpacesBounds);
	const initCoords = useSelector(getInitCoords);

	const { setActiveMarkerId } = useMapActions();

	const points = useSelector(getSpacesPoints);

	const staled = React.useMemo(
		() => {
			if (initCoords) {
				return {
					zoom: 17,
					center: {
						lat: initCoords.latitude,
						lng: initCoords.longitude,
					},
				};
			}
			return fitBounds(defaultBounds, {
				width: global.innerWidth || 0,
				height: global.innerHeight || 0,
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	const { fetchSpacesPoints: fetchMapPoints } = useFetchSpacesPoints();

	const fetchPoints = React.useCallback(
		(p) => {
			const { nw, se } = boundsRef.current;
			const bbox = `${nw.lng},${nw.lat}~${se.lng},${se.lat}`;
			const boundedParams = {
				...p,
				list: {
					...p.list,
					bbox,
					page: 1,
					perPage: 100,
				},
			};

			return fetchMapPoints(boundedParams);
		},
		[fetchMapPoints],
	);

	const handleMapChange = React.useMemo(
		() => async (map) => {
			const { bounds } = map;
			const { nw, se } = bounds;

			const isInside =
				boundsRef.current &&
				isInsideBounds(nw, boundsRef.current) &&
				isInsideBounds(se, boundsRef.current);

			// Tumbler)
			// eslint-disable-next-line no-constant-condition
			if (true || !isInside) {
				boundsRef.current = bounds;
				await fetchPoints(params);
			}
		},
		[fetchPoints, params],
	);

	useDeepUpdate(() => {
		fetchPoints(params);
	}, [params]);

	const handlePointClick = React.useCallback(
		(data) => {
			if (data.isActive) {
				setActiveMarkerId({ id: -1 });
			} else {
				setActiveMarkerId({ id: data.id });
			}
		},
		[setActiveMarkerId],
	);

	const definePointComponent = React.useCallback(({ properties }) => {
		if (properties.price !== undefined) {
			return MarkerPrice;
		}
		return MarkerPoint;
	}, []);

	const btnsSet = React.useMemo(() => {
		return {
			zoom: true,
		};
	}, []);

	return (
		<Map
			points={points}
			btnsSet={btnsSet}
			defaultCenter={staled.center}
			defaultZoom={staled.zoom}
			onMapChange={handleMapChange}
			onPointClick={handlePointClick}
			definePointComponent={definePointComponent}
			{...props}
		/>
	);
};

export default MapCSpaces;
